import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=e6711fa4&scoped=true"
import script from "./singleCustomer.vue?vue&type=script&lang=js"
export * from "./singleCustomer.vue?vue&type=script&lang=js"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=e6711fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6711fa4",
  null
  
)

export default component.exports